window.datePickerOptions = function (minDate = null, maxDate = null, dropdowns = false) {
  minDateOption = (typeof minDate == 'string' ? { minDate: moment(minDate, 'DD/MM/YYYY') } : {});
  maxDateOption = (typeof maxDate == 'string' ? { maxDate: moment(maxDate, 'DD/MM/YYYY') } : {});

  return {
    singleDatePicker: true,
    autoUpdateInput: false,
    ...minDateOption,
    ...maxDateOption,
    showDropdowns: dropdowns,
    "locale": {
      "format": "DD/MM/YYYY",
      "separator": " - ",
      "applyLabel": "Aplicar",
      "cancelLabel": "Limpar",
      "fromLabel": "De",
      "toLabel": "Até",
      "customRangeLabel": "Customizado",
      "weekLabel": "S",
      "daysOfWeek": ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
      "monthNames": ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
      "firstDay": 1
    }
  }
}

window.datatableOptions = {
  dom: `
    <'card-body py-2'
      <'row'
        <'col-md-6'B>
        <'col-md-6'f>
      >
    >
    <'row'
      <'col overflow-auto p-0'tr>
    >
    <'card-footer'
      <'row'
        <'col-md-6'l>
        <'col-md-6'p>>
      <'row'
        <'col  text-center'i>
      >
    >`,
  lengthMenu: [10, 25, 50, 100, 500],
  rowGroup: {
    enable: false
  },
  buttons: {
    dom: {
      button: {
        className: 'btn btn-primary'
      }
    },
    buttons: [
      {
        extend: 'copyHtml5',
        exportOptions: {
          columns: ':visible th:not(.no-export)'
        }
      },
      {
        extend: 'excelHtml5',
        exportOptions: {
          columns: ':visible th:not(.no-export)'
        }
      },
      {
        extend: 'csvHtml5',
        exportOptions: {
          columns: ':visible th:not(.no-export)'
        }
      },
      {
        extend: 'pdfHtml5',
        orientation: 'landscape',
        pageSize : 'LEGAL',
        title: function () {
          return $('table.datatable').data('export-title') || document.title;
        },
        exportOptions: {
          columns: ':visible th:not(.no-export)',
          format: {
            body: function ( data, row, column, node ) {
              return data.replace(/<br\s*\/?>/ig, "\r\n").replace(/<a.*>/ig, '').replace(/<\/a>/ig, '').trim();
            }
          }
        },
        customize: function (doc) {
          doc.defaultStyle.fontSize = pdfTableFontSize(doc);
          doc.styles.tableHeader.fontSize = doc.defaultStyle.fontSize;
          doc.styles.tableHeader.alignment = 'left';
          doc.content[1].table.widths = pdfTableColumnWidths(doc);
        }
      },
      {
        extend: 'colvis'
      }
    ]
  },
  language: {
    sEmptyTable: "Nenhum registro encontrado",
    sInfo: "Mostrando de _START_ até _END_ de _TOTAL_ registros",
    sInfoEmpty: "Mostrando 0 até 0 de 0 registros",
    sInfoFiltered: "(Filtrados de _MAX_ registros)",
    sInfoPostFix: "",
    sInfoThousands: ".",
    sLengthMenu: "_MENU_ resultados por página",
    sLoadingRecords: "Carregando...",
    sProcessing: "Processando...",
    sZeroRecords: "Nenhum registro encontrado",
    sSearch: "Pesquisar",
    oPaginate: {
      sNext: "Próxima",
      sPrevious: "Anterior",
      sFirst: "Primeira",
      sLast: "Última"
    },
    oAria: {
      sSortAscendin: "Ordenar colunas de forma ascendente",
      sSortDescendin: "Ordenar colunas de forma descendente"
    },
    buttons: {
      copy: 'Copiar',
      colvis: 'Exibindo colunas'
    }
  }
}

window.pdfTableFontSize = function (doc) {
  const columnCount = doc.content[1].table.body[0].length;
  if (columnCount > 36) { return 3; }
  if (columnCount > 20) { return 4; }
  if (columnCount > 12) { return 5; }
  if (columnCount > 8) { return 6; }
  if (columnCount > 6) { return 7; }
  return 8;
}

window.pdfTableColumnWidths = function (doc) {
  const columns = doc.content[1].table.body[0];
  const width = (930 / columns.length) - columns.length;
  return columns.map(function () {
    return width;
  });
}

window.getGroupButton = function (table) {
  buttons = [
    {
      text: 'nenhum',
      action: function (e, dt, node, config) {
        dt.rowGroup().disable().draw();
      }
    }
  ]

  table.DataTable().columns().header().to$().each(function () {
    const columnName = $(this).data('data');

    if (typeof columnName === 'undefined') { return; }

    buttons.push({
      text: $(this.innerHTML).text() || this.innerHTML,
      action: function (e, dt, node, config) {
        const index = dt.columns().dataSrc().indexOf(columnName);
        dt.order([index, 'desc']);
        dt.order.fixed({ pre: [index, 'asc'] });
        dt.rowGroup().enable().dataSrc(columnName).draw();
      }
    });
  });

  return {
    text: 'Agrupar',
    extend: 'collection',
    autoClose: true,
    buttons: buttons
  }
}

window.toastr.options = {
  'closeButton': true,
  'newestOnTop': true,
  'positionClass': 'toast-top-center'
}
